/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponListItemViewModel } from "../types/CouponListItemViewModel.ts";

export const couponListItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do cupom.")),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa associada ao cupom. Opcional.")
    .nullish(),
  description: z.string().describe("Descrição do cupom.").nullish(),
  dateStart: z.optional(
    z.string().datetime().describe("Data de início da validade do cupom."),
  ),
  dateEnd: z.optional(
    z.string().datetime().describe("Data final da validade do cupom."),
  ),
  active: z.optional(z.boolean().describe("Indica se o cupom está ativo.")),
}) as unknown as ToZod<CouponListItemViewModel>;
